import Swal, { SweetAlertPosition } from "sweetalert2";

const toast = Swal.mixin({});

const successToast = Swal.mixin({
  // position: "top-right",
  width: "300px",
  padding: "1rem",
});

export function fireToast(title: string, duration = 5000, position: SweetAlertPosition = 'top-right') {
  toast.fire({
    title: title,
    toast: true,
    showCloseButton: true,
    showConfirmButton: false,
    position,
    timer: duration,
    padding: "0.5rem",
    timerProgressBar: true,
    customClass: {
      title: "swal2-toast-title",
      timerProgressBar: "swal2-toast-progress",
      container: "swal2-toast-container",
      popup: "swal2-toast-popup",
    },
  });
}

export function fireAlert(type: string, title: string, text?: string) {
  switch (type) {
    case "error":
      toast.fire({
        title,
        text: text,
        icon: "error",
        showConfirmButton: true,
        customClass: {
          confirmButton: "swal-confirm-btn",
        },
      });
      break;
    case "success":
      successToast.fire({
        title,
        text: text,
        icon: "success",
        showConfirmButton: true,
        customClass: {
          confirmButton: "swal-confirm-btn",
        },
      });
      break;
    case "warning":
      toast.fire({
        title,
        text: text,
        icon: "warning",
        showConfirmButton: true,
        customClass: {
          confirmButton: "swal-confirm-btn",
          icon: "icon-center",
        },
      });
      break;
    case "question":
      toast.fire({
        title,
        text: text,
        icon: "question",
        showConfirmButton: true,
        customClass: {
          confirmButton: "swal-confirm-btn",
          icon: "icon-center",
        },
      });
      break;
    case "info":
      toast.fire({
        title,
        text: text,
        icon: "info",
        showConfirmButton: true,
        customClass: {
          confirmButton: "swal-confirm-btn",
          icon: "icon-center",
        },
      });
      break;
  }
}
